import emailjs, { init } from "emailjs-com";

function sendFormByEmail(
  name: string,
  formId: string,
  onError: () => void,
  onSuccess: () => void
) {
  init("user_OIERG8Y9OPLxZFT2yPJ12");
  emailjs.sendForm("service_ztl42qo", "joinus_form", formId).then(
    function (response) {
      onSuccess();
    },
    function (error) {
      console.error(error);
      onError();
    }
  );
}

export default sendFormByEmail;
